export const environment = {
    keycloakClientId:'formation',
    env: 'staging',
    baseHref: '/',
    keycloakRealm:'sigesr',
    keycloakUrl:'https://auth.cineri.sn',
    production: true,
    formationBaseUrl: 'https://fmt-staging.campusen.sn/api/formations',
    urlPattern: /^(https:\/\/fmt-staging.campusen.sn\/api\/formations)(\/.*)?$/i,

    listAppplication:[ {
    id: "dashboard",
    name: "Dashboard",
    description: "Outil d'aide à la décision",
    icon: "📊",
    color: "#F59E0B",
    url: "/dashboard"
  },
  {
    id: "campusen",
    name: "Campusen",
    description: "Gestion des orientations",
    icon: "🎓",
    color: "#EC4899",
    url: "https://orientation.campusen.sn/"
  },
  {
    id: "ine",
    name: "INE",
    description: "Identifiant National Étudiant",
    icon: "🆔",
    color: "#3B82F6",
    url: "https://auth.cineri.sn/ine/",
    isActive: true
  },
  {
    id: "formations",
    name: "Formations",
    description: "Les formations au Sénégal",
    icon: "📚",
    color: "#10B981",
    url: "https://auth.cineri.sn/formation/"
  },
  {
    id: "habilitation",
    name: "Habilitation",
    description: "Gestion du SCA",
    icon: "✅",
    color: "#8B5CF6",
    url: "https://auth.cineri.sn/habilitation/"
  },
 /* {
    id: "espace-etudiant",
    name: "Espace Etudiant",
    description: "Cursus de l'étudiant",
    icon: "👨‍🎓",
    color: "#06B6D4",
    url: "/espace-etudiant"
  },*/
  {
    id: "votes",
    name: "Votes",
    description: "Gestionnaire de votes",
    icon: "🗳️",
    color: "#6366F1",
    url: "/votes"
  }
    ]

};
